import { IPredictiveModelDetailInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';

import { PredictiveModels } from './resources/PredictiveModels';

export function getPredictiveModelDetailInfo(predictiveModelId: string): Promise<IPredictiveModelDetailInfo> {
  return PredictiveModels.getById(predictiveModelId);
}
